/**
 * Marca da Via Contabilidade, na mesma construção do site institucional
 * (`C:\Site-Via`, src/components/Logo.jsx): a barra com o degradê laranja→navy,
 * "VIA" com o ponto laranja e "CONTABILIDADE" espaçado embaixo.
 *
 * Aqui ela vem sempre sobre o navy do cabeçalho, então o texto é branco — não há
 * variante clara para manter, e o degradê da barra é invertido (navy→laranja
 * ficaria invisível contra o fundo).
 */
export function Logo({ produto }: { produto?: string }) {
  return (
    <div className="logo">
      <div className="logo-barra" aria-hidden="true" />
      <div className="logo-texto">
        <div className="logo-nome">
          VIA<span className="logo-ponto">.</span>
        </div>
        <div className="logo-sub">Contabilidade</div>
      </div>
      {produto ? (
        <>
          <div className="logo-sep" aria-hidden="true" />
          <div className="logo-produto">{produto}</div>
        </>
      ) : null}
    </div>
  );
}
